export default "__VITE_ASSET__DNXLAh$p__"